import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=c22a33dc&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=js"
export * from "./CatalogPage.vue?vue&type=script&lang=js"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=c22a33dc&prod&lang=scss&scoped=true"
import style1 from "./CatalogPage.vue?vue&type=style&index=1&id=c22a33dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a33dc",
  null
  
)

export default component.exports